import { IEvent } from "@Interfaces";
import { CURRENCY_STRINGS, CURRENCY_SYMBOLS } from "repoV2/constants/payment";

export default function getEventCurrencyForDisplaying({
    eventData,
}: {
    eventData: IEvent.IEventData;
}) {
    let eventCurrencySymbol = eventData?.currency || CURRENCY_SYMBOLS.INR;
    const eventCurrency = eventData?.currency_name || CURRENCY_STRINGS.INR;

    if (eventCurrencySymbol === CURRENCY_SYMBOLS.USD) {
        eventCurrencySymbol = CURRENCY_STRINGS.USD;
    }

    return {
        eventCurrencySymbol,
        eventCurrency,
    };
}
